<div class="checkin__navbar__wrapper" [@navbar]>
  <button class="checkin__navbar__item" *ngFor="let n of navbarItems" [routerLink]="n.route" (click)="onClick(n)" [routerLinkActive]="n?.route ? 'active' : ''">
    <div>
      <span *ngIf="n.notifications" class="checkin__navbar__item__notification">
        <span>{{ n.notifications }}</span>
      </span>
      <i class="{{ n.icon }}"></i>
    </div>
    <span *ngIf="n?.label?.slug" class="checkin__navbar__item__slug">{{ n.label.slug | translate }}</span>
  </button>
</div>
<app-slide-out
  *ngIf="animations.showSlideOut"
  [preventClose]="preventCloseSlideOut"
  [animationState]="animations.state"
  [slideOutType]="aditionalInfoSlideOutType"
  (closeSlideOut)="closeSlideOutHandler()">
  <app-navbar-aditional-info></app-navbar-aditional-info>
</app-slide-out>

